import VueI18n from 'vue-i18n';
// import realtime from './realtime';

const langs = ['en', 'es'];
const modules = [
    'access',
    'history',
    'report',
    'geofences',
    'mantto',
    'admin',
    'realtime',
    'catalogs',
    'roads',
    'executive',
    'cameras',
	'dynamic',
    'users',
    'presentationV4'
];

export const messages = {
    en: {},
    es: {}
};

for (const module in modules) {
    let mod = require(`./${modules[module]}`);
    // console.log(mod[modules[module]]['es']);
    let modn = modules[module];

    for (const lang in langs) {
        // console.log('Lang: ', langs[lang]);
        // console.log(mod[modules[module]][langs[lang]]);

        // console.log(messages[langs[lang]]);
        messages[langs[lang]][modn] = mod[modn][langs[lang]];
    }
}
// console.log(messages);
